<ng-template #checkoutCrossTooltip>
  <div class="d-flex flex-column" style="width: 30vw !important; min-width: 30vw;">
    <b>
      Utilize o Cross Checkout para impulsionar suas vendas!
    </b>
    <span>
      Aproveite essa opção para direcionar seus clientes a uma página de checkout personalizada, onde os dados do cliente serão automaticamente preenchidos, tornando o processo de compra mais fluido e aumentando as chances de conversão.
    </span>
  </div>
</ng-template>

<div class="sequences">
  <div class="seq-head" *ngIf="sequences">
    <h3><i class="fa fa-bolt"></i> Sequência <span class="pill-count">{{ sequences?.length || 0 }}</span></h3>
    <div class="add-bar" data-testid="sequence-add-bar">
      <span class="add-lbl">Adicionar</span>
      <button type="button" class="sf-btn sf-btn--primary" (click)="newOfType('sms', modalSequence)" data-testid="btn-new-sms">
        <i class="fa fa-comment"></i> Mensagem SMS
      </button>
      <button type="button" class="sf-btn sf-btn--secondary btn-wa" (click)="openWhatsapp()" *ngIf="whatsappAvailable"
              [disabled]="!accountsError && !hasWhatsappNumber" [title]="accountsError || hasWhatsappNumber ? '' : 'Conecte um número de WhatsApp'" data-testid="btn-new-whatsapp">
        <i class="fa fa-whatsapp"></i> WhatsApp
      </button>
      <!-- RCS (17tm466frtx): só com o canal ligado na conta. Abre o mesmo editor do envio em massa. -->
      <button type="button" class="sf-btn sf-btn--secondary" (click)="newOfType('rcs', modalSequence)" *ngIf="rcsEnabled"
              data-testid="btn-new-rcs">
        <i class="fa fa-commenting"></i> RCS
      </button>
      <button type="button" class="sf-btn sf-btn--ghost" (click)="newOfType('call4u', modalSequence)" data-testid="btn-new-call">
        <i class="fa fa-phone"></i> Voz
      </button>
      <button type="button" class="sf-btn sf-btn--ghost" (click)="newOfType('webhook', modalSequence)" data-testid="btn-new-webhook">
        <i class="fa fa-link"></i> Webhook
      </button>
      <button type="button" class="sf-btn sf-btn--ghost" (click)="newOfType('active_campaign', modalSequence)" *ngIf="campaign?.lead_list"
              [disabled]="!campaign.ac_infos" [title]="campaign.ac_infos ? '' : 'Ative o Active Campaign antes de utilizar.'" data-testid="btn-new-ac">
        <i class="fa fa-send"></i> Active Campaign
      </button>
    </div>
    <span class="field-hint no-number" *ngIf="whatsappAvailable && !loadingAccounts && !accountsError && !hasWhatsappNumber" data-testid="hint-no-whatsapp">
      <i class="fa fa-info-circle"></i> Conecte um número em <a routerLink="/whatsapp-integration">Integrações WhatsApp</a> para usar aqui.
    </span>
    <span class="field-hint no-number" *ngIf="whatsappAvailable && accountsError" data-testid="hint-accounts-error">
      <i class="fa fa-exclamation-triangle"></i> Não foi possível carregar seus números ·
      <button type="button" class="retry-link" (click)="loadAccounts()" data-testid="btn-retry-accounts">Tentar de novo</button>
    </span>
  </div>

  <app-skeleton *ngIf="loadingSequences" variant="text" [count]="3"
    label="Carregando as sequências" data-testid="sequences-loading"></app-skeleton>

  <section class="sf-card empty" *ngIf="sequences && !loadingSequences && !sequences.length" data-testid="sequences-empty">
    <i class="fa fa-bolt"></i>
    <p>Nenhum passo ainda. Comece por <strong>Mensagem SMS</strong><ng-container *ngIf="whatsappAvailable">{{ rcsEnabled ? ', ' : ' ou ' }}<strong>WhatsApp</strong></ng-container><ng-container *ngIf="rcsEnabled"> ou <strong>RCS</strong></ng-container>.</p>
  </section>

  <section
    class="seq-item"
    *ngFor="let sequence of sequences"
    [hidden]="loadingSequences"
    [class.off]="!sequence.active"
    [class.wa]="sequence.sequence_type === 'whatsapp'"
    [class.legacy]="sequence.sequence_type === 'voxuy' || isLegacyWhatsapp(sequence)"
    [class.ai]="sequence.sequence_type === 'controls_ai'"
    [class.rcs]="sequence.sequence_type === 'rcs'"
    [class.call]="sequence.sequence_type === 'call4u'"
    [class.hook]="sequence.sequence_type === 'webhook'"
    data-testid="sequence-item"
  >
    <div>
      <app-switcher
        *ngIf="sequence.sequence_type !== 'controls_ai'"
        look="v2"
        [color]="!sequence.active"
        [checked]="sequence.active"
        (change)="toggleActive(sequence)"
      >
      </app-switcher>
    </div>

    <div class="when">
      <span class="type" [ngClass]="typeClass(sequence)">
        <i [class]="getMsgTypeIcon(sequence)" class="fa"></i>
        {{ getMessageType(sequence) }}
      </span>
      <span class="after">Após {{ sequence.interval + " " + (sequence.interval_type?.name || '') }}</span>
    </div>

    <div class="body" [ngSwitch]="bodyKind(sequence)">
      <ng-container *ngSwitchCase="'whatsapp'">
        <div class="txt"><strong>{{ sequence.template_name }}</strong><span *ngIf="itemBodies[sequence.id]"> · {{ itemBodies[sequence.id] }}</span></div>
        <div class="meta" data-testid="wa-item-meta">
          <span class="bind-chip bind-chip--wa" *ngIf="sequence.whatsapp_account"><i class="fa fa-whatsapp"></i> {{ sequence.whatsapp_account.name }}</span>
          <span class="chip" *ngIf="itemVariables[sequence.id]?.summary" data-testid="wa-item-vars"><i class="fa fa-tag"></i> {{ itemVariables[sequence.id].summary }}</span>
          <span class="bind-chip bind-chip--warn" *ngIf="itemVariables[sequence.id]?.defaulted?.length" data-testid="wa-item-vars-default"
                title="Este passo foi salvo antes de dar para escolher o dado de variáveis com nome. Edite e salve para confirmar.">
            <i class="fa fa-exclamation-triangle"></i> {{ itemVariables[sequence.id].defaulted.join(', ') }} sem dado escolhido — vai o primeiro nome do lead
          </span>
          <span class="bind-chip bind-chip--danger" *ngIf="itemVariables[sequence.id]?.missing?.length" data-testid="wa-item-vars-missing">
            <i class="fa fa-exclamation-circle"></i> {{ itemVariables[sequence.id].missing.join(', ') }} sem dado — envios cancelados até editar o passo
          </span>
          <span class="chip" *ngIf="hasFollowup(sequence)"><i class="fa fa-clock-o"></i> {{ followupSummary(sequence) }}</span>
          <span class="bind-chip bind-chip--ai" *ngIf="sequence.ai_agent_id"><i class="fa fa-magic"></i> IA: {{ sequence.ai_agent?.name || 'agente' }}</span>
          <span class="meta-chip" *ngIf="!sequence.ai_agent_id"><i class="fa fa-user"></i> Sem IA — resposta humana</span>
          <span class="bind-chip bind-chip--danger" *ngIf="accountBroken(sequence)" data-testid="wa-item-broken">
            <i class="fa fa-exclamation-circle"></i> Número com token expirado — envios aguardando
          </span>
          <span class="bind-chip bind-chip--warn" *ngIf="sequence.ai_agent && !sequence.ai_agent.active" data-testid="wa-item-agent-off">
            <i class="fa fa-exclamation-triangle"></i> Agente inativo — IA não responde
          </span>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'wa-legacy'">
        <div class="txt">{{ sequence.text }} <span class="chip chip--muted">legado · somente leitura</span></div>
        <div class="meta">
          <span class="chip" data-testid="wa-legacy"><i class="fa fa-exclamation-triangle"></i> Passo do “Meu WhatsApp” antigo, sem template: recrie como passo WhatsApp com o seu número</span>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'voxuy'">
        <div class="txt">Campanha Voxuy: “{{ sequence.voxuy_campaign_description || sequence.voxuy_campaign_url }}” <span class="chip chip--muted">legado · somente leitura</span></div>
        <div class="meta">
          <span class="chip" data-testid="voxuy-legacy"><i class="fa fa-exclamation-triangle"></i> Substitua por um passo WhatsApp até {{ voxuyCutoff }}</span>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'controls_ai'">
        <div class="txt">Um agente inicia a conversa no WhatsApp e responde o lead sozinho. <span class="chip chip--muted">configurada em IA → Listas & eventos</span></div>
        <div class="meta">
          <a class="bind-chip bind-chip--ai" *ngIf="sequence.ai_agent_id" [routerLink]="['/playground-ia', sequence.ai_agent_id, 'lists']" data-testid="ai-legacy-link">
            <i class="fa fa-magic"></i> Abrir em Listas & eventos{{ sequence.ai_agent?.name ? ' · ' + sequence.ai_agent.name : '' }}
          </a>
          <!-- controls_ai anterior a 29/06 pode não ter agente gravado: o caminho é a lista de agentes. -->
          <a class="bind-chip bind-chip--ai" *ngIf="!sequence.ai_agent_id" routerLink="/playground-ia" data-testid="ai-legacy-link-fallback">
            <i class="fa fa-magic"></i> Abrir Meus Agentes
          </a>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'rcs'">
        <div class="txt" *ngIf="sequence.rcs_content?.cards?.length; else singleRcsSummary">Carrossel · {{ sequence.rcs_content.cards.length }} cards · {{ sequence.rcs_content.cards[0]?.title }} {{ sequence.rcs_content.cards[0]?.text }}</div>
        <ng-template #singleRcsSummary><div class="txt"><strong *ngIf="sequence.rcs_content?.title">{{ sequence.rcs_content.title }} · </strong>{{ sequence.rcs_content?.text }}</div></ng-template>
        <div class="meta" data-testid="rcs-item-meta">
          <span class="bind-chip bind-chip--rcs" *ngIf="rcsAgentName(sequence) as agentName" data-testid="rcs-item-agent"><i class="fa fa-commenting"></i> {{ agentName }}</span>
          <span class="chip" *ngIf="rcsButtonCount(sequence) as buttons" data-testid="rcs-item-buttons"><i class="fa fa-hand-pointer-o"></i> {{ buttons }} {{ buttons === 1 ? 'botão' : 'botões' }}</span>
          <!-- Condição por leitura: só com a flag ligada (sem o retorno da Pingoo ela não age, 03/11/2026). -->
          <span class="chip" *ngIf="readConditionSettings.enabled && sequence.rcs_read_condition" data-testid="rcs-item-read-condition"><i class="fa fa-clock-o"></i> Se não ler em {{ sequence.rcs_read_condition.hours }} h: SMS</span>
        </div>
        <!-- Etapa RCS com agente fora de Ativo: pausada, sem cobrança (seção 3.2 da spec). -->
        <div class="rcs-notice rcs-notice--bad mt-2" *ngIf="rcsPausedAgent(sequence) as agent" data-testid="rcs-step-paused">
          <i class="fa fa-pause-circle"></i>
          <span><strong>Etapa pausada:</strong> o agente {{ agent.name }} está
            {{ rcsStageLabels[agent.stage] | lowercase }}. Nada é cobrado até ele voltar a ficar ativo.</span>
        </div>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <div class="txt">{{ sequence.text || sequence.call4u_audio?.tts_text || sequence.call4u_audio?.title || sequence.call4u_campaign_description }}</div>
        <div class="meta" *ngIf="sequence.url && sequence.text?.includes('{meu_link}')">
          <span class="chip"><i class="fa fa-link"></i> Meu link: {{ sequence.url }}</span>
        </div>
      </ng-container>
    </div>

    <div class="buttons">
      <a
        *ngIf="!isReadOnly(sequence)"
        class="sf-btn sf-btn--primary sf-btn--icon sf-btn--sm"
        role="button"
        aria-label="Editar sequência"
        (click)="edit(sequence, modalSequence)"
        data-testid="btn-edit-sequence"
      >
        <i class="fa fa-pencil"></i>
      </a>
      <a class="sf-btn sf-btn--danger sf-btn--icon sf-btn--sm" role="button" aria-label="Remover sequência" (click)="remove(sequence)" data-testid="btn-removal-sequence"
         *ngIf="sequence.sequence_type !== 'controls_ai'">
        <i class="fa fa-trash"></i>
      </a>
    </div>
  </section>
</div>

<ng-template #modalSequence let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      <i class="fa" [ngClass]="{ 'fa-comment': sequenceType === 'sms', 'fa-phone': sequenceType === 'call4u', 'fa-link': sequenceType === 'webhook', 'fa-send': sequenceType === 'active_campaign', 'fa-commenting': sequenceType === 'rcs' }"></i>
      {{ modalTitle }}
      <span class="sub" *ngIf="campaign?.name">{{ campaign.name }}</span>
    </h4>
    <button
      type="button"
      class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm"
      aria-label="Fechar"
      (click)="modal.dismiss('CLOSE')"
    >
      <i class="fa fa-times"></i>
    </button>
  </div>

  <div class="modal-body seq-modal">
    <form *ngIf="sequenceType === 'sms'" (submit)="save(modal)" [formGroup]="sequenceForm">
      <div class="notice notice--warning notice--sm">
        <i class="fa fa-exclamation-triangle"></i>
        <div class="notice__body"><span>Lembre-se que está enviando SMS: <strong>não use acento nem emoji</strong>. Limite de {{ messageMaxLength }} caracteres.</span></div>
      </div>
      <div class="sms-grid" data-testid="click-form">
        <div class="field">
          <label for="text">Mensagem</label>
          <textarea
            id="text"
            name="text"
            rows="5"
            class="form-control"
            formControlName="text"
            placeholder="Digite a mensagem..."
            [maxlength]="messageMaxLength"
            (blur)="setPosition($event)"
            (input)="messageContentChanged($event)"
            data-testid="area-message-campaign"
          ></textarea>
          <small class="counter">{{ sequenceForm.get('text').value?.length || 0 }}/{{ messageMaxLength }}</small>
          <small
            class="field-error"
            *ngIf="sequenceForm.get('text').errors?.maxlength"
          >
            O texto deve ter apenas 150 caracteres
          </small>
        </div>
        <div class="field">
          <label>Variáveis que podem ser usadas</label>
          <div class="var-chips">
            <button
              type="button"
              *ngFor="let tag of tags"
              class="var-chip"
              (click)="addTag(tag.tag)"
              [ngbTooltip]="tag.title"
            >
              {{ tag.tag }}
            </button>
          </div>
          <span class="field-hint">Clique para inserir na posição do cursor.</span>
        </div>
      </div>

      <ng-container *ngIf="smsUsesLink; else smsLinkHint">
        <div class="field">
          <label for="url">Meu link</label>
          <input
            type="text"
            name="url"
            id="url"
            class="form-control"
            placeholder="Exemplo: https://exemplo.com"
            formControlName="url"
            data-testid="area-link-campaign"
          />
          <span
            class="field-error"
            *ngIf="sequenceForm.get('url').errors?.invalidUrl"
            >URL Inválida! Exemplo: <u>https://exemplo.com</u></span
          >
        </div>
        <div class="field">
          <app-switcher id="user_active" look="v2" label="Enviar número do lead na URL?" [(checked)]="sendLeadNumber" data-testid="switch-send-lead-number" />
        </div>
      </ng-container>
      <ng-template #smsLinkHint>
        <div class="notice notice--sm" data-testid="sms-link-hint">
          <i class="fa fa-info-circle"></i>
          <div class="notice__body"><span>Para incluir um link na mensagem, use a variável <strong>{{ '{' }}meu_link{{ '}' }}</strong>: o campo “Meu link” aparece aqui.</span></div>
        </div>
      </ng-template>

      <ng-container *ngIf="have_list_integration">
        <div class="field">
          <label for="cross_checkout_url">
            <span [ngbTooltip]="checkoutCrossTooltip" tooltipClass="cctooltip">Checkout Cross <i class="fa fa-question-circle"></i></span>
            <span class="new-chip">Novo</span>
          </label>
          <input
            type="text"
            name="cross_checkout_url"
            id="cross_checkout_url"
            class="form-control"
            placeholder="Exemplo: https://exemplo.com"
            formControlName="cross_checkout_url"
            (input)="detectPlatformCrossCheckout()"
          />
          <span
            class="field-error"
            *ngIf="sequenceForm.get('cross_checkout_url') && sequenceForm.get('cross_checkout_url').getRawValue() && sequenceForm.get('cross_checkout_url').errors?.invalidUrl"
            >URL Inválida! Exemplo: <u>https://exemplo.com</u></span
          >
          <span class="field-ok" *ngIf="checkout_cross_platform && checkout_cross_platform !== ''">
            <i class="fa fa-check-circle"></i> Plataforma detectada: {{ checkout_cross_platform }}
          </span>
        </div>
      </ng-container>

      <div class="field-grid" [class.field-grid--3]="have_list_integration" [class.field-grid--2]="!have_list_integration">
        <div class="field" *ngIf="have_list_integration">
          <label for="coupon">
            <span ngbTooltip="Você pode usar este campo para fornecer o cupom de desconto disponível para o cross checkout. Seu cliente não precisará digitar o código, pois nós nos encarregaremos do preenchimento automático.">Cupom <i class="fa fa-question-circle"></i></span>
            <span class="new-chip">Novo</span>
          </label>
          <input
            type="text"
            class="form-control"
            name="coupon"
            id="coupon"
            formControlName="coupon"
            placeholder="Exemplo: DESCONTO100"
          />
        </div>

        <div class="field">
          <label for="interval">Após entrada na lista</label>
          <input
            type="number"
            class="form-control"
            name="interval"
            id="interval"
            formControlName="interval"
            data-testid="input-enty-list"
          />
          <small
            class="field-error"
            *ngIf="sequenceForm.get('interval').errors?.required"
            data-testid="alert-interval-required"
          >
            O intervalo é obrigatório
          </small>
        </div>

        <div class="field">
          <label for="interval_type_id_modal">Unidade</label>
          <select
            class="form-select"
            name="interval_type_id"
            id="interval_type_id_modal"
            formControlName="interval_type_id"
            data-testid="select-interval-type"
          >
            <option
              *ngFor="let intervalType of intervalTypes"
              [value]="intervalType.id"
            >
              {{ intervalType.name }}
            </option>
          </select>
          <small
            class="field-error"
            *ngIf="sequenceForm.get('interval_type_id').errors?.required"
            data-testid="alert-interval-type-required"
          >
            O tipo intervalo é obrigatório
          </small>
        </div>
      </div>
    </form>

    <!-- Etapa RCS (17tm466frtx): o mesmo editor do envio em massa. -->
    <form *ngIf="sequenceType === 'rcs'" (submit)="save(modal)" [formGroup]="sequenceForm" data-testid="rcs-sequence-form">
      <div class="rcs-scope rcs-stack">
        <!-- Quando enviar: o mesmo cartão das telas RCS (layout novo, 03/11/2026). -->
        <section class="rcs-card" data-testid="rcs-when">
          <h5 class="rcs-card__title"><i class="fa fa-clock-o"></i> Quando enviar</h5>
          <div class="rcs-grid-2 rcs-when">
            <div class="rcs-field">
              <label for="rcs_interval">Após entrada na lista</label>
              <input type="number" id="rcs_interval" class="form-control" formControlName="interval" min="0"
                data-testid="rcs-interval" />
              <small class="field-error" *ngIf="sequenceForm.get('interval').errors?.required">O intervalo é obrigatório</small>
            </div>
            <div class="rcs-field">
              <label for="rcs_interval_type">Unidade</label>
              <select id="rcs_interval_type" class="form-select" formControlName="interval_type_id">
                <option *ngFor="let intervalType of intervalTypes" [value]="intervalType.id">{{ intervalType.name }}</option>
              </select>
            </div>
          </div>
        </section>

        <app-rcs-editor context="sequence" [variables]="rcsVariables" [(agentId)]="rcsAgentId" [content]="rcsContent"
          (contentChange)="rcsContent = $event" (stateChange)="rcsState = $event"></app-rcs-editor>

        <!-- {url_checkout_cross} e {cupom} saem como no SMS da automação (03/11/2026): os mesmos campos da etapa SMS. -->
        <section class="rcs-card rcs-stack" *ngIf="have_list_integration" data-testid="rcs-cross-checkout">
          <h5 class="rcs-card__title"><i class="fa fa-shopping-cart"></i> Checkout Cross e cupom</h5>
          <div class="rcs-grid-2">
            <div class="rcs-field">
              <label for="rcs_cross_checkout_url">
                <span [ngbTooltip]="checkoutCrossTooltip" tooltipClass="cctooltip">Checkout Cross <i class="fa fa-question-circle"></i></span>
              </label>
              <input type="text" id="rcs_cross_checkout_url" class="form-control" formControlName="cross_checkout_url"
                placeholder="Exemplo: https://exemplo.com" (input)="detectPlatformCrossCheckout()" data-testid="rcs-cross-checkout-url" />
              <small class="field-error"
                *ngIf="sequenceForm.get('cross_checkout_url')?.getRawValue() && sequenceForm.get('cross_checkout_url')?.errors?.invalidUrl">
                URL Inválida! Exemplo: <u>https://exemplo.com</u></small>
              <span class="field-ok" *ngIf="checkout_cross_platform && checkout_cross_platform !== ''">
                <i class="fa fa-check-circle"></i> Plataforma detectada: {{ checkout_cross_platform }}
              </span>
            </div>
            <div class="rcs-field">
              <label for="rcs_coupon">Cupom</label>
              <input type="text" id="rcs_coupon" class="form-control" formControlName="coupon" placeholder="Exemplo: DESCONTO100"
                data-testid="rcs-coupon" />
            </div>
          </div>
          <p class="rcs-hint">Usados pelas variáveis {{ '{' }}url_checkout_cross{{ '}' }} e {{ '{' }}cupom{{ '}' }}, do mesmo jeito que no SMS.</p>
        </section>

        <!-- Condição por leitura (F7.5, D8): só com a flag RCS_SEQUENCE_READ_CONDITION ligada. Desligada, nada aparece
             (decisão do Bruno, 03/11/2026: sem o retorno da Pingoo ela não funciona; o código fica para religar). -->
        <div class="rcs-card rcs-stack" *ngIf="readConditionSettings.enabled"
          data-testid="rcs-read-condition">
          <label class="rcs-check">
            <input type="checkbox" [checked]="readConditionOn" (change)="readConditionOn = $any($event.target).checked"
              data-testid="rcs-read-condition-toggle" />
            <span>Se a mensagem RCS não for lida no prazo, enviar um SMS</span>
          </label>

          <ng-container *ngIf="readConditionOn">
            <div class="rcs-grid-2">
              <div class="rcs-field">
                <label for="rcs_read_hours">Se não ler em (horas)</label>
                <input type="number" id="rcs_read_hours" class="form-control" step="1"
                  [min]="readConditionSettings.min_hours" [max]="readConditionSettings.max_hours"
                  [value]="readConditionHours" (input)="readConditionHours = $any($event.target).valueAsNumber"
                  data-testid="rcs-read-condition-hours" />
                <p class="rcs-hint">De {{ readConditionSettings.min_hours }} a {{ readConditionSettings.max_hours }} h depois que o RCS sai.</p>
              </div>
            </div>
            <div class="rcs-field">
              <label for="rcs_read_sms">
                Enviar SMS
                <span class="rcs-field__count" data-testid="rcs-read-condition-count"
                  [class.rcs-error]="readConditionText.length > readConditionSettings.sms_max_length">
                  {{ readConditionText.length }}/{{ readConditionSettings.sms_max_length }}
                </span>
              </label>
              <textarea id="rcs_read_sms" class="form-control" rows="3"
                [class.is-invalid]="readConditionText.length > readConditionSettings.sms_max_length"
                [value]="readConditionText" (input)="readConditionText = $any($event.target).value"
                placeholder="Oi {first_name}, seu pedido ainda está reservado: {url_checkout}"
                data-testid="rcs-read-condition-text"></textarea>
              <p class="rcs-hint">Mesmas variáveis do SMS desta etapa; links viram link curto, acentos saem e o texto é cortado em
                {{ readConditionSettings.sms_max_length }}. Cobrado como SMS. Não sai se a mensagem for lida (ou clicada), se ela
                já tiver ido por SMS ou se o lead sair da sequência.</p>
              <p class="rcs-error" *ngFor="let problem of readConditionProblems" data-testid="rcs-read-condition-error">{{ problem }}</p>
            </div>
          </ng-container>
        </div>
      </div>
    </form>

    <form *ngIf="sequenceType === 'call4u' && usedCall4U" (submit)="save(modal)" [formGroup]="sequenceForm" data-testid="form-call">
      <div class="field">
        <label for="call4u_audio_id">Áudio da ligação</label>
        <select
          id="call4u_audio_id"
          class="form-select"
          formControlName="call4u_audio_id"
          data-testid="select-call-audio"
        >
          <option [ngValue]="null" disabled>Selecione um áudio...</option>
          <option *ngFor="let audio of call4uAudios" [ngValue]="audio.id">
            {{ audio.title }} ({{ audio.type === 'tts' ? 'TTS' : 'Upload' }} - {{ formatDuration(audio.duration_seconds) }})
          </option>
        </select>
        <div *ngIf="call4uAudios.length === 0" class="notice notice--warning notice--sm">
          <i class="fa fa-exclamation-triangle"></i>
          <div class="notice__body"><span>Nenhum áudio aprovado encontrado. Cadastre um áudio em Call4U &gt; Áudios.</span></div>
        </div>
      </div>

      <div *ngIf="getSelectedAudio() as audio" class="audio-info" data-testid="call-audio-info">
        <span class="audio-info__ic"><i class="fa fa-volume-up"></i></span>
        <div>
          <div class="audio-info__t">{{ audio.title }} <span class="chip">{{ audio.type === 'tts' ? 'TTS' : 'Upload' }}</span></div>
          <div class="audio-info__s">Duração: {{ formatDuration(audio.duration_seconds) }}</div>
        </div>
      </div>

      <div class="field-grid field-grid--2">
        <div class="field">
          <label for="call_max_attempts">Tentativas máximas</label>
          <input
            type="number"
            class="form-control"
            name="call_max_attempts"
            id="call_max_attempts"
            formControlName="call_max_attempts"
            min="1"
            max="10"
          />
          <small class="field-hint">Quantas vezes tentar ligar se não atender (1-10)</small>
        </div>
        <div class="field">
          <label for="call_retry_interval_minutes">Intervalo entre tentativas (min)</label>
          <input
            type="number"
            class="form-control"
            name="call_retry_interval_minutes"
            id="call_retry_interval_minutes"
            formControlName="call_retry_interval_minutes"
            min="1"
          />
          <small class="field-hint">Minutos para aguardar antes de tentar novamente</small>
        </div>
      </div>

      <div class="field-grid field-grid--2">
        <div class="field">
          <label for="inteval_call">Após entrada na lista</label>
          <input
            type="number"
            class="form-control"
            name="interval"
            id="inteval_call"
            formControlName="interval"
          />
          <small
            class="field-error"
            *ngIf="sequenceForm.get('interval').errors?.required"
          >
            O intervalo é obrigatório
          </small>
        </div>

        <div class="field">
          <label for="interval_type_id_call">Unidade</label>
          <select
            class="form-select"
            name="interval_type_id"
            id="interval_type_id_call"
            formControlName="interval_type_id"
          >
            <option
              *ngFor="let intervalType of intervalTypes"
              [value]="intervalType.id"
            >
              {{ intervalType.name }}
            </option>
          </select>
          <small
            class="field-error"
            *ngIf="sequenceForm.get('interval_type_id').errors?.required"
          >
            O tipo intervalo é obrigatório
          </small>
        </div>
      </div>

      <div class="notice notice--sm">
        <i class="fa fa-clock-o"></i>
        <div class="notice__body">
          <span>As ligações são realizadas apenas entre <strong>07:30 e 23:00</strong> (horário de Brasília).
            Se agendada fora desse horário, será cancelada automaticamente.</span>
        </div>
      </div>
    </form>

    <form *ngIf="sequenceType === 'webhook'" (submit)="save(modal)" [formGroup]="sequenceForm" data-testid="form-webhook">
      <div class="field">
        <label for="call4u_campaign_url">Link do webhook</label>
        <input type="text" class="form-control" id="call4u_campaign_url" placeholder="Digite a URL do webhook" name="call4u_campaign_url" formControlName="call4u_campaign_url" data-testid="input-webhook-url"/>
        <small class="field-error" *ngIf="sequenceForm.get('call4u_campaign_url').value && sequenceForm.get('call4u_campaign_url').errors?.invalidUrl">URL Inválida! Exemplo: <u>https://exemplo.com</u></small>
        <small class="field-hint">Chamamos esta URL no momento deste passo da sequência.</small>
      </div>
      <div class="field">
        <div class="field-head">
          <label for="call4u_campaign_description">Descrição breve</label>
          <small class="counter">{{ sequenceForm.get("call4u_campaign_description").value ? sequenceForm.get("call4u_campaign_description").value.length : 0 }}/80</small>
        </div>
        <input type="text" class="form-control" id="call4u_campaign_description" maxlength="80" placeholder="Digite uma descrição para identificar este webhook" name="call4u_campaign_description" formControlName="call4u_campaign_description" data-testid="input-webhook-description"/>
      </div>

      <div class="field-grid field-grid--2">
        <div class="field">
          <label for="interval_webhook">Após entrada na lista</label>
          <input
            type="number"
            class="form-control"
            name="interval"
            id="interval_webhook"
            formControlName="interval"
          />
          <small
            class="field-error"
            *ngIf="sequenceForm.get('interval').errors?.required"
          >
            O intervalo é obrigatório
          </small>
        </div>

        <div class="field">
          <label for="interval_type_id_webhook">Unidade</label>
          <select
            class="form-select"
            name="interval_type_id"
            id="interval_type_id_webhook"
            formControlName="interval_type_id"
          >
            <option
              *ngFor="let intervalType of intervalTypes"
              [value]="intervalType.id"
            >
              {{ intervalType.name }}
            </option>
          </select>
          <small
            class="field-error"
            *ngIf="sequenceForm.get('interval_type_id').errors?.required"
          >
            O tipo intervalo é obrigatório
          </small>
        </div>
      </div>
    </form>

    <form *ngIf="sequenceType === 'active_campaign' && campaign.ac_infos !== null" (submit)="save(modal)" [formGroup]="sequenceForm" data-testid="form-ac">
      <p class="section-hint">Escolha as tags do Active Campaign que o lead recebe neste passo: marque e use as setas para mover entre as colunas.</p>
      <div class="ac-tags">
        <div class="ac-panel">
          <div class="ac-panel__head">
            <span class="lbl-u">Disponíveis</span>
            <div class="ac-panel__actions">
              <button
                type="button"
                class="sf-btn sf-btn--secondary sf-btn--icon sf-btn--sm"
                aria-label="Atualizar tags"
                ngbTooltip="Atualizar tags"
                (click)="refreshACInfo()"
                [disabled]="refreshAC"
              >
                <i class="fa fa-refresh"></i>
              </button>
              <button
                type="button"
                class="sf-btn sf-btn--primary sf-btn--sm"
                (click)="newTag(modalTag)"
              >
                <i class="fa fa-plus-circle"></i>
                Nova tag
              </button>
            </div>
          </div>
          <div class="ac-panel__body">
            <label *ngFor="let tag of AC_tags" class="ac-pick">
              <input type="checkbox" class="badge-select" hidden (click)="preSelectACTagAll(tag)" [checked]="tagIsInPreselected(tag)"/>
              <span class="ac-tag" [ngbTooltip]="tag.description">
                {{ tag.tag }}
                <span (click)="editTag(modalTag, tag)" class="badge-opt" role="button" aria-label="Editar tag">
                  <i class="fa fa-pencil"></i>
                </span>
                <span (click)="deleteTag(tag)" class="badge-opt badge-opt--danger" role="button" aria-label="Excluir tag"><i class="fa fa-trash"></i></span>
              </span>
            </label>
          </div>
          <small class="ac-panel__count">{{ AC_preselected_all.length }} selecionada(s)</small>
        </div>
        <div class="ac-arrows">
          <button
            type="button"
            class="sf-btn sf-btn--primary sf-btn--icon sf-btn--sm"
            aria-label="Adicionar"
            ngbTooltip="Adicionar"
            (click)="toSelect()"
          >
            <i class="fa fa-arrow-right"></i>
          </button>
          <button
            type="button"
            class="sf-btn sf-btn--secondary sf-btn--icon sf-btn--sm"
            aria-label="Remover"
            ngbTooltip="Remover"
            (click)="toAll()"
          >
            <i class="fa fa-arrow-left"></i>
          </button>
        </div>
        <div class="ac-panel">
          <div class="ac-panel__head">
            <span class="lbl-u">Selecionadas</span>
          </div>
          <div class="ac-panel__body">
            <label *ngFor="let tag of AC_selected_tags" class="ac-pick">
              <input type="checkbox" class="badge-select" hidden (click)="preSelectACTagSelected(tag)" [checked]="tagIsInPreselected(tag)"/>
              <span class="ac-tag" [ngbTooltip]="tag.description">
                {{ tag.tag }}
              </span>
            </label>
          </div>
          <small class="ac-panel__count">{{ AC_preselected_selected.length }} selecionada(s)</small>
        </div>
      </div>

      <div class="field">
        <label for="url_active">Meu link</label>
        <input
          type="text"
          class="form-control"
          name="url"
          id="url_active"
          formControlName="url"
          placeholder="Exemplo: https://exemplo.com"
        />
      </div>

      <div class="field-grid field-grid--2">
        <div class="field">
          <label for="inteval">Após entrada na lista</label>
          <input
            type="number"
            class="form-control"
            name="interval"
            id="inteval"
            formControlName="interval"
          />
          <small
            class="field-error"
            *ngIf="sequenceForm.get('interval').errors?.required"
          >
            O intervalo é obrigatório
          </small>
        </div>
        <div class="field">
          <label for="interval_type_id">Unidade</label>
          <select
            class="form-select"
            name="interval_type_id"
            id="interval_type_id"
            formControlName="interval_type_id"
          >
            <option
              *ngFor="let intervalType of intervalTypes"
              [value]="intervalType.id"
            >
              {{ intervalType.name }}
            </option>
          </select>
          <small
            class="field-error"
            *ngIf="sequenceForm.get('interval_type_id').errors?.required"
          >
            O tipo intervalo é obrigatório
          </small>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="sf-btn sf-btn--ghost push" (click)="modal.dismiss('CANCEL')" data-testid="btn-cancel-edit-sequence">
      Cancelar
    </button>
    <button
      type="button"
      class="sf-btn sf-btn--primary"
      (click)="save(modal)"
      [appLoadingButton]="saving"
      [disabled]="sequenceForm.invalid"
      data-testid="btn-save-edit-sequence"
    >
      <i class="fa fa-save"></i> Salvar
    </button>
  </div>
</ng-template>

<ng-template #modalTag let-tagModal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-tag-title">
      <i class="fa fa-tag"></i>
      {{ tagMode === 1 ? 'Nova tag' : "Editar tag" }}
      <span class="sub">Active Campaign</span>
    </h4>
    <button
      type="button"
      class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm"
      aria-label="Fechar"
      (click)="tagModal.dismiss('CLOSE')"
    >
      <i class="fa fa-times"></i>
    </button>
  </div>

  <div class="modal-body">
    <form (submit)="saveTag(tagModal)" [formGroup]="tagForm">
      <div class="field-grid field-grid--1">
        <div class="field">
          <label for="tag-name">Nome</label>
          <input
            id="tag-name"
            name="name"
            class="form-control"
            formControlName="name"
            placeholder="Digite aqui o nome da sua tag..."
            required
          />
        </div>
        <div class="field">
          <label for="tag-description">Descrição</label>
          <input
            id="tag-description"
            name="description"
            class="form-control"
            formControlName="description"
            placeholder="Digite aqui a descrição da sua tag..."
          />
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="sf-btn sf-btn--ghost push"
      (click)="tagModal.dismiss()"
    >
      Cancelar
    </button>
    <button
      type="button"
      class="sf-btn sf-btn--primary"
      (click)="saveTag(tagModal)"
      [disabled]="tagForm.invalid"
    >
      <i class="fa fa-save"></i> Salvar
    </button>
  </div>
</ng-template>

<ac-activate-popup
  [integrationId]="campaign.lead_list && campaign.lead_list.integration ? campaign.lead_list.integration.id : ''"
 *ngIf="sequenceType === 'active_campaign' && campaign.ac_infos == null"></ac-activate-popup>

<call4u-activate-popup [onClose]="close" (activated)="onCall4uActivated($event)" *ngIf="sequenceType === 'call4u' && !usedCall4U"></call4u-activate-popup>
